import styled from 'styled-components'

export const StyledWrapper = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 70px;
`

export const StyledTitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`

export const StyledButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  padding-bottom: 40px;
`
